<template>
  <ui-menu
    v-model="menu"
    :content-class="contentClass + ' ' + 'main-menu-events'"
    :location="location"
    :offset="offset"
    :close-on-content-click="false"
  >
    <template #activator="{ props }">
      <slot name="activator" v-bind="{ props }" :value="menu" />
    </template>

    <template #menu>
      <navbar-events-menu
        background-color="transparent"
        :change-plan-click="onChangePlanClick"
      />
    </template>
  </ui-menu>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import NavbarEventsMenu from '@/views/layout/navigation/navbar-events-menu.vue';

const props = withDefaults(
  defineProps<{
    changePlanClick?: () => void;
    contentClass?: string;
    location?: string;
    offset?: [number, number];
    closeMenu?: () => void;
  }>(),
  {
    contentClass: '',
    location: 'bottom start',
    offset: () => [0, 8],
  },
);

const menu = ref(false);

const onChangePlanClick = () => {
  menu.value = false;
  props.changePlanClick?.();
};
</script>

<style lang="scss">
.v-overlay__content.main-menu-events {
  min-width: 240px !important;
  max-width: 300px !important;
  background: var(--color-white);
  border-radius: 8px !important;
  overflow: hidden;
}
</style>
